/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as DashboardRouteImport } from './routes/dashboard'
import { Route as AcceptTransferRouteImport } from './routes/accept-transfer'
import { Route as AcceptInviteRouteImport } from './routes/accept-invite'
import { Route as IndexRouteImport } from './routes/index'
import { Route as DashboardIndexRouteImport } from './routes/dashboard/index'
import { Route as DashboardTeamChatRouteImport } from './routes/dashboard/team-chat'
import { Route as DashboardTeamRouteImport } from './routes/dashboard/team'
import { Route as DashboardStaffScheduleRouteImport } from './routes/dashboard/staff-schedule'
import { Route as DashboardSocialsRouteImport } from './routes/dashboard/socials'
import { Route as DashboardSettingsRouteImport } from './routes/dashboard/settings'
import { Route as DashboardServicesRouteImport } from './routes/dashboard/services'
import { Route as DashboardServiceRequestsRouteImport } from './routes/dashboard/service-requests'
import { Route as DashboardSecurityRouteImport } from './routes/dashboard/security'
import { Route as DashboardRolesRouteImport } from './routes/dashboard/roles'
import { Route as DashboardRewardsRouteImport } from './routes/dashboard/rewards'
import { Route as DashboardReviewsRouteImport } from './routes/dashboard/reviews'
import { Route as DashboardReportsRouteImport } from './routes/dashboard/reports'
import { Route as DashboardRecurringBookingsRouteImport } from './routes/dashboard/recurring-bookings'
import { Route as DashboardPrescriptionsRouteImport } from './routes/dashboard/prescriptions'
import { Route as DashboardPaymentsRouteImport } from './routes/dashboard/payments'
import { Route as DashboardPatientsRouteImport } from './routes/dashboard/patients'
import { Route as DashboardOrgChartRouteImport } from './routes/dashboard/org-chart'
import { Route as DashboardInvoicesRouteImport } from './routes/dashboard/invoices'
import { Route as DashboardCertificatesRouteImport } from './routes/dashboard/certificates'
import { Route as DashboardCalendarRouteImport } from './routes/dashboard/calendar'
import { Route as DashboardBookingQueueRouteImport } from './routes/dashboard/booking-queue'
import { Route as DashboardAuditLogsRouteImport } from './routes/dashboard/audit-logs'
import { Route as DashboardAppointmentsRouteImport } from './routes/dashboard/appointments'
import { Route as DashboardMemberMemberIdRouteImport } from './routes/dashboard/member.$memberId'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardRoute = DashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const AcceptTransferRoute = AcceptTransferRouteImport.update({
  id: '/accept-transfer',
  path: '/accept-transfer',
  getParentRoute: () => rootRouteImport,
} as any)
const AcceptInviteRoute = AcceptInviteRouteImport.update({
  id: '/accept-invite',
  path: '/accept-invite',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardIndexRoute = DashboardIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardTeamChatRoute = DashboardTeamChatRouteImport.update({
  id: '/team-chat',
  path: '/team-chat',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardTeamRoute = DashboardTeamRouteImport.update({
  id: '/team',
  path: '/team',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardStaffScheduleRoute = DashboardStaffScheduleRouteImport.update({
  id: '/staff-schedule',
  path: '/staff-schedule',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardSocialsRoute = DashboardSocialsRouteImport.update({
  id: '/socials',
  path: '/socials',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardSettingsRoute = DashboardSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardServicesRoute = DashboardServicesRouteImport.update({
  id: '/services',
  path: '/services',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardServiceRequestsRoute =
  DashboardServiceRequestsRouteImport.update({
    id: '/service-requests',
    path: '/service-requests',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardSecurityRoute = DashboardSecurityRouteImport.update({
  id: '/security',
  path: '/security',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardRolesRoute = DashboardRolesRouteImport.update({
  id: '/roles',
  path: '/roles',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardRewardsRoute = DashboardRewardsRouteImport.update({
  id: '/rewards',
  path: '/rewards',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardReviewsRoute = DashboardReviewsRouteImport.update({
  id: '/reviews',
  path: '/reviews',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardReportsRoute = DashboardReportsRouteImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardRecurringBookingsRoute =
  DashboardRecurringBookingsRouteImport.update({
    id: '/recurring-bookings',
    path: '/recurring-bookings',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardPrescriptionsRoute = DashboardPrescriptionsRouteImport.update({
  id: '/prescriptions',
  path: '/prescriptions',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardPaymentsRoute = DashboardPaymentsRouteImport.update({
  id: '/payments',
  path: '/payments',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardPatientsRoute = DashboardPatientsRouteImport.update({
  id: '/patients',
  path: '/patients',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardOrgChartRoute = DashboardOrgChartRouteImport.update({
  id: '/org-chart',
  path: '/org-chart',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardInvoicesRoute = DashboardInvoicesRouteImport.update({
  id: '/invoices',
  path: '/invoices',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardCertificatesRoute = DashboardCertificatesRouteImport.update({
  id: '/certificates',
  path: '/certificates',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardCalendarRoute = DashboardCalendarRouteImport.update({
  id: '/calendar',
  path: '/calendar',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardBookingQueueRoute = DashboardBookingQueueRouteImport.update({
  id: '/booking-queue',
  path: '/booking-queue',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardAuditLogsRoute = DashboardAuditLogsRouteImport.update({
  id: '/audit-logs',
  path: '/audit-logs',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardAppointmentsRoute = DashboardAppointmentsRouteImport.update({
  id: '/appointments',
  path: '/appointments',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardMemberMemberIdRoute = DashboardMemberMemberIdRouteImport.update({
  id: '/member/$memberId',
  path: '/member/$memberId',
  getParentRoute: () => DashboardRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/accept-invite': typeof AcceptInviteRoute
  '/accept-transfer': typeof AcceptTransferRoute
  '/dashboard': typeof DashboardRouteWithChildren
  '/login': typeof LoginRoute
  '/dashboard/appointments': typeof DashboardAppointmentsRoute
  '/dashboard/audit-logs': typeof DashboardAuditLogsRoute
  '/dashboard/booking-queue': typeof DashboardBookingQueueRoute
  '/dashboard/calendar': typeof DashboardCalendarRoute
  '/dashboard/certificates': typeof DashboardCertificatesRoute
  '/dashboard/invoices': typeof DashboardInvoicesRoute
  '/dashboard/org-chart': typeof DashboardOrgChartRoute
  '/dashboard/patients': typeof DashboardPatientsRoute
  '/dashboard/payments': typeof DashboardPaymentsRoute
  '/dashboard/prescriptions': typeof DashboardPrescriptionsRoute
  '/dashboard/recurring-bookings': typeof DashboardRecurringBookingsRoute
  '/dashboard/reports': typeof DashboardReportsRoute
  '/dashboard/reviews': typeof DashboardReviewsRoute
  '/dashboard/rewards': typeof DashboardRewardsRoute
  '/dashboard/roles': typeof DashboardRolesRoute
  '/dashboard/security': typeof DashboardSecurityRoute
  '/dashboard/service-requests': typeof DashboardServiceRequestsRoute
  '/dashboard/services': typeof DashboardServicesRoute
  '/dashboard/settings': typeof DashboardSettingsRoute
  '/dashboard/socials': typeof DashboardSocialsRoute
  '/dashboard/staff-schedule': typeof DashboardStaffScheduleRoute
  '/dashboard/team': typeof DashboardTeamRoute
  '/dashboard/team-chat': typeof DashboardTeamChatRoute
  '/dashboard/': typeof DashboardIndexRoute
  '/dashboard/member/$memberId': typeof DashboardMemberMemberIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/accept-invite': typeof AcceptInviteRoute
  '/accept-transfer': typeof AcceptTransferRoute
  '/login': typeof LoginRoute
  '/dashboard/appointments': typeof DashboardAppointmentsRoute
  '/dashboard/audit-logs': typeof DashboardAuditLogsRoute
  '/dashboard/booking-queue': typeof DashboardBookingQueueRoute
  '/dashboard/calendar': typeof DashboardCalendarRoute
  '/dashboard/certificates': typeof DashboardCertificatesRoute
  '/dashboard/invoices': typeof DashboardInvoicesRoute
  '/dashboard/org-chart': typeof DashboardOrgChartRoute
  '/dashboard/patients': typeof DashboardPatientsRoute
  '/dashboard/payments': typeof DashboardPaymentsRoute
  '/dashboard/prescriptions': typeof DashboardPrescriptionsRoute
  '/dashboard/recurring-bookings': typeof DashboardRecurringBookingsRoute
  '/dashboard/reports': typeof DashboardReportsRoute
  '/dashboard/reviews': typeof DashboardReviewsRoute
  '/dashboard/rewards': typeof DashboardRewardsRoute
  '/dashboard/roles': typeof DashboardRolesRoute
  '/dashboard/security': typeof DashboardSecurityRoute
  '/dashboard/service-requests': typeof DashboardServiceRequestsRoute
  '/dashboard/services': typeof DashboardServicesRoute
  '/dashboard/settings': typeof DashboardSettingsRoute
  '/dashboard/socials': typeof DashboardSocialsRoute
  '/dashboard/staff-schedule': typeof DashboardStaffScheduleRoute
  '/dashboard/team': typeof DashboardTeamRoute
  '/dashboard/team-chat': typeof DashboardTeamChatRoute
  '/dashboard': typeof DashboardIndexRoute
  '/dashboard/member/$memberId': typeof DashboardMemberMemberIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/accept-invite': typeof AcceptInviteRoute
  '/accept-transfer': typeof AcceptTransferRoute
  '/dashboard': typeof DashboardRouteWithChildren
  '/login': typeof LoginRoute
  '/dashboard/appointments': typeof DashboardAppointmentsRoute
  '/dashboard/audit-logs': typeof DashboardAuditLogsRoute
  '/dashboard/booking-queue': typeof DashboardBookingQueueRoute
  '/dashboard/calendar': typeof DashboardCalendarRoute
  '/dashboard/certificates': typeof DashboardCertificatesRoute
  '/dashboard/invoices': typeof DashboardInvoicesRoute
  '/dashboard/org-chart': typeof DashboardOrgChartRoute
  '/dashboard/patients': typeof DashboardPatientsRoute
  '/dashboard/payments': typeof DashboardPaymentsRoute
  '/dashboard/prescriptions': typeof DashboardPrescriptionsRoute
  '/dashboard/recurring-bookings': typeof DashboardRecurringBookingsRoute
  '/dashboard/reports': typeof DashboardReportsRoute
  '/dashboard/reviews': typeof DashboardReviewsRoute
  '/dashboard/rewards': typeof DashboardRewardsRoute
  '/dashboard/roles': typeof DashboardRolesRoute
  '/dashboard/security': typeof DashboardSecurityRoute
  '/dashboard/service-requests': typeof DashboardServiceRequestsRoute
  '/dashboard/services': typeof DashboardServicesRoute
  '/dashboard/settings': typeof DashboardSettingsRoute
  '/dashboard/socials': typeof DashboardSocialsRoute
  '/dashboard/staff-schedule': typeof DashboardStaffScheduleRoute
  '/dashboard/team': typeof DashboardTeamRoute
  '/dashboard/team-chat': typeof DashboardTeamChatRoute
  '/dashboard/': typeof DashboardIndexRoute
  '/dashboard/member/$memberId': typeof DashboardMemberMemberIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/accept-invite'
    | '/accept-transfer'
    | '/dashboard'
    | '/login'
    | '/dashboard/appointments'
    | '/dashboard/audit-logs'
    | '/dashboard/booking-queue'
    | '/dashboard/calendar'
    | '/dashboard/certificates'
    | '/dashboard/invoices'
    | '/dashboard/org-chart'
    | '/dashboard/patients'
    | '/dashboard/payments'
    | '/dashboard/prescriptions'
    | '/dashboard/recurring-bookings'
    | '/dashboard/reports'
    | '/dashboard/reviews'
    | '/dashboard/rewards'
    | '/dashboard/roles'
    | '/dashboard/security'
    | '/dashboard/service-requests'
    | '/dashboard/services'
    | '/dashboard/settings'
    | '/dashboard/socials'
    | '/dashboard/staff-schedule'
    | '/dashboard/team'
    | '/dashboard/team-chat'
    | '/dashboard/'
    | '/dashboard/member/$memberId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/accept-invite'
    | '/accept-transfer'
    | '/login'
    | '/dashboard/appointments'
    | '/dashboard/audit-logs'
    | '/dashboard/booking-queue'
    | '/dashboard/calendar'
    | '/dashboard/certificates'
    | '/dashboard/invoices'
    | '/dashboard/org-chart'
    | '/dashboard/patients'
    | '/dashboard/payments'
    | '/dashboard/prescriptions'
    | '/dashboard/recurring-bookings'
    | '/dashboard/reports'
    | '/dashboard/reviews'
    | '/dashboard/rewards'
    | '/dashboard/roles'
    | '/dashboard/security'
    | '/dashboard/service-requests'
    | '/dashboard/services'
    | '/dashboard/settings'
    | '/dashboard/socials'
    | '/dashboard/staff-schedule'
    | '/dashboard/team'
    | '/dashboard/team-chat'
    | '/dashboard'
    | '/dashboard/member/$memberId'
  id:
    | '__root__'
    | '/'
    | '/accept-invite'
    | '/accept-transfer'
    | '/dashboard'
    | '/login'
    | '/dashboard/appointments'
    | '/dashboard/audit-logs'
    | '/dashboard/booking-queue'
    | '/dashboard/calendar'
    | '/dashboard/certificates'
    | '/dashboard/invoices'
    | '/dashboard/org-chart'
    | '/dashboard/patients'
    | '/dashboard/payments'
    | '/dashboard/prescriptions'
    | '/dashboard/recurring-bookings'
    | '/dashboard/reports'
    | '/dashboard/reviews'
    | '/dashboard/rewards'
    | '/dashboard/roles'
    | '/dashboard/security'
    | '/dashboard/service-requests'
    | '/dashboard/services'
    | '/dashboard/settings'
    | '/dashboard/socials'
    | '/dashboard/staff-schedule'
    | '/dashboard/team'
    | '/dashboard/team-chat'
    | '/dashboard/'
    | '/dashboard/member/$memberId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AcceptInviteRoute: typeof AcceptInviteRoute
  AcceptTransferRoute: typeof AcceptTransferRoute
  DashboardRoute: typeof DashboardRouteWithChildren
  LoginRoute: typeof LoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard': {
      id: '/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/accept-transfer': {
      id: '/accept-transfer'
      path: '/accept-transfer'
      fullPath: '/accept-transfer'
      preLoaderRoute: typeof AcceptTransferRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/accept-invite': {
      id: '/accept-invite'
      path: '/accept-invite'
      fullPath: '/accept-invite'
      preLoaderRoute: typeof AcceptInviteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/': {
      id: '/dashboard/'
      path: '/'
      fullPath: '/dashboard/'
      preLoaderRoute: typeof DashboardIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/team-chat': {
      id: '/dashboard/team-chat'
      path: '/team-chat'
      fullPath: '/dashboard/team-chat'
      preLoaderRoute: typeof DashboardTeamChatRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/team': {
      id: '/dashboard/team'
      path: '/team'
      fullPath: '/dashboard/team'
      preLoaderRoute: typeof DashboardTeamRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/staff-schedule': {
      id: '/dashboard/staff-schedule'
      path: '/staff-schedule'
      fullPath: '/dashboard/staff-schedule'
      preLoaderRoute: typeof DashboardStaffScheduleRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/socials': {
      id: '/dashboard/socials'
      path: '/socials'
      fullPath: '/dashboard/socials'
      preLoaderRoute: typeof DashboardSocialsRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/settings': {
      id: '/dashboard/settings'
      path: '/settings'
      fullPath: '/dashboard/settings'
      preLoaderRoute: typeof DashboardSettingsRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/services': {
      id: '/dashboard/services'
      path: '/services'
      fullPath: '/dashboard/services'
      preLoaderRoute: typeof DashboardServicesRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/service-requests': {
      id: '/dashboard/service-requests'
      path: '/service-requests'
      fullPath: '/dashboard/service-requests'
      preLoaderRoute: typeof DashboardServiceRequestsRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/security': {
      id: '/dashboard/security'
      path: '/security'
      fullPath: '/dashboard/security'
      preLoaderRoute: typeof DashboardSecurityRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/roles': {
      id: '/dashboard/roles'
      path: '/roles'
      fullPath: '/dashboard/roles'
      preLoaderRoute: typeof DashboardRolesRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/rewards': {
      id: '/dashboard/rewards'
      path: '/rewards'
      fullPath: '/dashboard/rewards'
      preLoaderRoute: typeof DashboardRewardsRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/reviews': {
      id: '/dashboard/reviews'
      path: '/reviews'
      fullPath: '/dashboard/reviews'
      preLoaderRoute: typeof DashboardReviewsRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/reports': {
      id: '/dashboard/reports'
      path: '/reports'
      fullPath: '/dashboard/reports'
      preLoaderRoute: typeof DashboardReportsRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/recurring-bookings': {
      id: '/dashboard/recurring-bookings'
      path: '/recurring-bookings'
      fullPath: '/dashboard/recurring-bookings'
      preLoaderRoute: typeof DashboardRecurringBookingsRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/prescriptions': {
      id: '/dashboard/prescriptions'
      path: '/prescriptions'
      fullPath: '/dashboard/prescriptions'
      preLoaderRoute: typeof DashboardPrescriptionsRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/payments': {
      id: '/dashboard/payments'
      path: '/payments'
      fullPath: '/dashboard/payments'
      preLoaderRoute: typeof DashboardPaymentsRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/patients': {
      id: '/dashboard/patients'
      path: '/patients'
      fullPath: '/dashboard/patients'
      preLoaderRoute: typeof DashboardPatientsRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/org-chart': {
      id: '/dashboard/org-chart'
      path: '/org-chart'
      fullPath: '/dashboard/org-chart'
      preLoaderRoute: typeof DashboardOrgChartRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/invoices': {
      id: '/dashboard/invoices'
      path: '/invoices'
      fullPath: '/dashboard/invoices'
      preLoaderRoute: typeof DashboardInvoicesRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/certificates': {
      id: '/dashboard/certificates'
      path: '/certificates'
      fullPath: '/dashboard/certificates'
      preLoaderRoute: typeof DashboardCertificatesRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/calendar': {
      id: '/dashboard/calendar'
      path: '/calendar'
      fullPath: '/dashboard/calendar'
      preLoaderRoute: typeof DashboardCalendarRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/booking-queue': {
      id: '/dashboard/booking-queue'
      path: '/booking-queue'
      fullPath: '/dashboard/booking-queue'
      preLoaderRoute: typeof DashboardBookingQueueRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/audit-logs': {
      id: '/dashboard/audit-logs'
      path: '/audit-logs'
      fullPath: '/dashboard/audit-logs'
      preLoaderRoute: typeof DashboardAuditLogsRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/appointments': {
      id: '/dashboard/appointments'
      path: '/appointments'
      fullPath: '/dashboard/appointments'
      preLoaderRoute: typeof DashboardAppointmentsRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/member/$memberId': {
      id: '/dashboard/member/$memberId'
      path: '/member/$memberId'
      fullPath: '/dashboard/member/$memberId'
      preLoaderRoute: typeof DashboardMemberMemberIdRouteImport
      parentRoute: typeof DashboardRoute
    }
  }
}

interface DashboardRouteChildren {
  DashboardAppointmentsRoute: typeof DashboardAppointmentsRoute
  DashboardAuditLogsRoute: typeof DashboardAuditLogsRoute
  DashboardBookingQueueRoute: typeof DashboardBookingQueueRoute
  DashboardCalendarRoute: typeof DashboardCalendarRoute
  DashboardCertificatesRoute: typeof DashboardCertificatesRoute
  DashboardInvoicesRoute: typeof DashboardInvoicesRoute
  DashboardOrgChartRoute: typeof DashboardOrgChartRoute
  DashboardPatientsRoute: typeof DashboardPatientsRoute
  DashboardPaymentsRoute: typeof DashboardPaymentsRoute
  DashboardPrescriptionsRoute: typeof DashboardPrescriptionsRoute
  DashboardRecurringBookingsRoute: typeof DashboardRecurringBookingsRoute
  DashboardReportsRoute: typeof DashboardReportsRoute
  DashboardReviewsRoute: typeof DashboardReviewsRoute
  DashboardRewardsRoute: typeof DashboardRewardsRoute
  DashboardRolesRoute: typeof DashboardRolesRoute
  DashboardSecurityRoute: typeof DashboardSecurityRoute
  DashboardServiceRequestsRoute: typeof DashboardServiceRequestsRoute
  DashboardServicesRoute: typeof DashboardServicesRoute
  DashboardSettingsRoute: typeof DashboardSettingsRoute
  DashboardSocialsRoute: typeof DashboardSocialsRoute
  DashboardStaffScheduleRoute: typeof DashboardStaffScheduleRoute
  DashboardTeamRoute: typeof DashboardTeamRoute
  DashboardTeamChatRoute: typeof DashboardTeamChatRoute
  DashboardIndexRoute: typeof DashboardIndexRoute
  DashboardMemberMemberIdRoute: typeof DashboardMemberMemberIdRoute
}

const DashboardRouteChildren: DashboardRouteChildren = {
  DashboardAppointmentsRoute: DashboardAppointmentsRoute,
  DashboardAuditLogsRoute: DashboardAuditLogsRoute,
  DashboardBookingQueueRoute: DashboardBookingQueueRoute,
  DashboardCalendarRoute: DashboardCalendarRoute,
  DashboardCertificatesRoute: DashboardCertificatesRoute,
  DashboardInvoicesRoute: DashboardInvoicesRoute,
  DashboardOrgChartRoute: DashboardOrgChartRoute,
  DashboardPatientsRoute: DashboardPatientsRoute,
  DashboardPaymentsRoute: DashboardPaymentsRoute,
  DashboardPrescriptionsRoute: DashboardPrescriptionsRoute,
  DashboardRecurringBookingsRoute: DashboardRecurringBookingsRoute,
  DashboardReportsRoute: DashboardReportsRoute,
  DashboardReviewsRoute: DashboardReviewsRoute,
  DashboardRewardsRoute: DashboardRewardsRoute,
  DashboardRolesRoute: DashboardRolesRoute,
  DashboardSecurityRoute: DashboardSecurityRoute,
  DashboardServiceRequestsRoute: DashboardServiceRequestsRoute,
  DashboardServicesRoute: DashboardServicesRoute,
  DashboardSettingsRoute: DashboardSettingsRoute,
  DashboardSocialsRoute: DashboardSocialsRoute,
  DashboardStaffScheduleRoute: DashboardStaffScheduleRoute,
  DashboardTeamRoute: DashboardTeamRoute,
  DashboardTeamChatRoute: DashboardTeamChatRoute,
  DashboardIndexRoute: DashboardIndexRoute,
  DashboardMemberMemberIdRoute: DashboardMemberMemberIdRoute,
}

const DashboardRouteWithChildren = DashboardRoute._addFileChildren(
  DashboardRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AcceptInviteRoute: AcceptInviteRoute,
  AcceptTransferRoute: AcceptTransferRoute,
  DashboardRoute: DashboardRouteWithChildren,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
